import { FBA_PREP_BREAKDOWN_ROWS } from '../../data/fbaPrepPricingData';
import './FbaPrepCostBreakdown.css';

export default function FbaPrepCostBreakdown() {
  return (
    <section className="fba-cost-breakdown" aria-labelledby="fba-cost-breakdown-heading">
      <div className="fba-cost-breakdown-head">
        <p className="fba-cost-breakdown-eyebrow">Prep Centre Fees Explained</p>
        <h2 id="fba-cost-breakdown-heading" className="fba-cost-breakdown-title">
          Amazon FBA Prep Cost Breakdown by Service
        </h2>
        <p className="fba-cost-breakdown-lead">
          Our Amazon FBA prep pricing is transparent, scalable, and designed to support businesses of every size. Compare our Silver, Gold and Platinum volume tiers to see how your FBA prep costs reduce as monthly order volumes increase. Every tier includes essential Amazon preparation services, while optional add-ons cover products requiring extra handling or protective packaging. All prices are exclusive of VAT. Use our Live Fulfilment Cost Calculator above for a tailored estimate based on your products and fulfilment requirements.
        </p>
      </div>

      <div className="fba-cost-breakdown-scroll" role="region" aria-label="FBA prep pricing table" tabIndex={0}>
        <table className="fba-cost-breakdown-table">
          <caption className="fba-cost-breakdown-caption">
            Pick Pack Pro FBA prep pricing — Silver, Gold and Platinum volume tiers (GBP, ex VAT)
          </caption>
          <thead>
            <tr>
              <th scope="col">Service</th>
              <th scope="col">Silver (1–1,999/mo)</th>
              <th scope="col">Gold (2,000–4,999/mo)</th>
              <th scope="col">Platinum (5,000+/mo)</th>
              <th scope="col">What&apos;s included</th>
            </tr>
          </thead>
          <tbody>
            {FBA_PREP_BREAKDOWN_ROWS.map((row) => (
              <tr key={row.service}>
                <th scope="row">{row.service}</th>
                <td>{row.silver}</td>
                <td>{row.gold}</td>
                <td>{row.platinum}</td>
                <td>{row.included}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
